import { Card } from '@/components/ui/card';
import { cn } from '@/lib/utils';

const CardWrapper: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ children, className }) => {
  return (
    <Card
      style={{
        background:
          'linear-gradient(154.36deg, rgba(47, 47, 47, 0.44) 11.3%, rgba(47, 47, 47, 0.44) 95.38%)',
      }}
      className={cn('border-0 p-6 space-y-6 rounded-[20px]', className)}
    >
      {children}
    </Card>
  );
};
export default CardWrapper;
